import React from 'react';
import Icon from 'components/Common/Icons/Icon/Icon';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const IconArrowUp = ({ className }: Props) => (
  <Icon className={className}>
    <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        transform="rotate(180 5.75736 3.12132)"
        id="svg_1"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="2"
        stroke="#333333"
        d="m1.51472,1l4.24264,4.24264l4.24264,-4.24264"
      />
    </svg>
  </Icon>
);

export default IconArrowUp;
